import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NodeService } from '®shared/hierarchy';

import {
  NodeSearchActionTypes,
  NodeSearchFailedAction,
  NodeSearchInitiatedAction,
  NodeSearchResultsLoadedAction,
} from './node-search.actions';

@Injectable()
export class NodeSearchEffects {
  constructor(private actions$: Actions, private nodeService: NodeService) {}

  searchForNodes$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(NodeSearchActionTypes.NODE_SEARCH_INITIATED),
      switchMap(({ payload }: NodeSearchInitiatedAction) =>
        this.nodeService.searchNodes(payload.searchTerm, payload.limit).pipe(
          map(
            results =>
              new NodeSearchResultsLoadedAction({ ...payload, results }),
          ),
          catchError(error =>
            observableOf(new NodeSearchFailedAction({ ...payload, error })),
          ),
        ),
      ),
    ),
  );
}
